var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLRocketMortgageRgbHorzInv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652.8 70.2",
    style: {
      enableBackground: "new 0 0 652.8 70.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#C8102E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.1,26.2l21.3,27.4h-15.3l-19.5-25.6v25.6h-12.8V1.4h12.8v23.3l18.9-23.3h15.2L191.1,26.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "231,42.9 255.9,42.9 255.9,53.6 218.2,53.6 218.2,1.4 254.7,1.4 254.7,12.1 231,12.1 231,21.7  252.4,21.7 252.4,32.1 231,32.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.1,1.4 261.1,12.1 277,12.1 277,53.6 289.8,53.6 289.8,12.1 305.6,12.1 305.6,1.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.1,1.4 261.1,12.1 277,12.1 277,53.6 289.8,53.6 289.8,12.1 305.6,12.1 305.6,1.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.9,33.5l15.7,20.1H31.8L13.1,28.5v25.2H0.3V1.4h23.5c11.2,0,19,6.9,19,16.9 C42.8,25.4,38.2,31.8,30.9,33.5z M30.1,18.5c0-3.9-3.1-6.6-7.5-6.6h-9.4v13.2h9.4C27.1,25.1,30.1,22.4,30.1,18.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,11.8c9.4,0,16.8,7.2,16.8,17.1c0,7.8-3.9,12.5-9.1,16l7.2,9.6c8.9-6.1,14.5-14.5,14.5-25.6 c0-16.4-13-28.3-29.4-28.3s-29.4,12-29.4,28.3c0,11.1,5.6,19.5,14.5,25.6l7.2-9.6c-5.2-3.5-9.1-8.2-9.1-16 C60.8,19,68.1,11.8,77.5,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,39.2l6.7,9.1c-4.9,4.3-10.9,6.2-18.4,6.2c-14.7,0-27.4-10.7-27.4-27.1c0-16,12.6-26.9,27.4-26.9 c7.1,0,13.5,1.8,18.3,5.7l-7,9.5c-2.8-2.2-6.2-3.9-11.3-3.9c-8.1,0-14.6,6.4-14.6,15.9c0,9.3,6.5,15.6,14.8,15.6 C145.5,43.2,149,41.4,151.9,39.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.5,1.4h8.4l16.8,24.3l16.9-24.3h8.6v52.2h-7.4V12.2l-16.9,24.3h-2.4l-16.6-24.3v41.4h-7.4V1.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.6,35.1c0-11.2,8.2-19.3,19.5-19.3c11.5,0,19.5,8.1,19.5,19.3c0,11.2-7.9,19.3-19.5,19.3 C391.8,54.3,383.6,46.3,383.6,35.1z M415.5,35.1c0-7.6-5.1-12.7-12.4-12.7c-7.2,0-12.3,5.1-12.3,12.7c0,7.6,5.2,12.7,12.3,12.7 C410.5,47.8,415.5,42.6,415.5,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.1,16.5v6.4h-2.9c-7.1,0-10.2,5.1-10.2,12.6v18h-6.9V16.5h6.9v6.5c2.4-4.8,6.2-6.5,10.3-6.5H449.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460,39.5V22.8h-6.4v-6.3h6.4V5.9l7-2.3v12.9h10.4v6.3H467v15.7c0,6.2,3.3,8.8,9.3,8.8h0.7l-1.1,6.8h-0.3 C465.1,54.2,460,49.6,460,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.9,16.5v34.3c0,12.2-7.4,18.8-19.2,18.8c-8.4,0-13.7-3.1-17.4-8L489,58c2.1,2.6,5.7,5.4,12,5.4 c7.5,0,11.9-4.3,11.9-12.1v-4.6c-2.9,4.7-7.6,6.9-13.4,6.9c-10.4,0-17.9-7.8-17.9-18.7c0-10.9,7.3-19,17.9-19 c6,0,10.4,2.5,13.4,6.9v-6.2H519.9z M513.1,34.6c0-6.7-5.1-12.6-12.2-12.6c-7.4,0-12.2,5.6-12.2,12.8c0,7.4,5.1,12.6,12.3,12.6 C508.3,47.4,513.1,41.8,513.1,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.4,16.5v37.1h-7v-6.5c-2.9,5.1-7.8,7.2-13.5,7.2c-10.4,0-17.9-8-17.9-19.2c0-11.3,7.5-19.3,17.9-19.3 c5.7,0,10.8,2.4,13.5,7.1v-6.3H564.4z M557.8,35.1c0-7.4-5.4-12.8-12.5-12.8c-7.1,0-12,5.1-12,12.9c0,7.6,4.8,12.7,11.9,12.7 C552.4,47.9,557.8,42.4,557.8,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M609,16.5v34.3c0,12.2-7.4,18.8-19.2,18.8c-8.4,0-13.7-3.1-17.4-8l5.7-3.6c2.1,2.6,5.7,5.4,12,5.4 c7.5,0,11.9-4.3,11.9-12.1v-4.6c-2.9,4.7-7.6,6.9-13.4,6.9c-10.4,0-17.9-7.8-17.9-18.7c0-10.9,7.3-19,17.9-19 c6,0,10.4,2.5,13.4,6.9v-6.2H609z M602.2,34.6c0-6.7-5.1-12.6-12.2-12.6c-7.4,0-12.2,5.6-12.2,12.8c0,7.4,5.1,12.6,12.3,12.6 C597.4,47.4,602.2,41.8,602.2,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M651.9,37.1h-29.5c0.7,6.9,5.2,11.2,11.8,11.2c5.2,0,8.5-2.3,10.8-4.6l4.8,3.6c-2.9,3.5-7.6,7.1-15.7,7.1 c-11.4,0-18.7-8.3-18.7-19.1c0-11.1,7.9-19.3,18.5-19.3c10.7,0,18,7.9,18,20.3V37.1z M644.6,32c-0.7-6.5-4.7-10.4-10.6-10.4 c-5.7,0-10.6,3.8-11.5,10.4H644.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLRocketMortgageRgbHorzInv);
export default __webpack_public_path__ + "static/media/L-RocketMortgage-RGB-Horz-Inv.2bbef13c855188a399d44c68301eabf4.svg";
export { ForwardRef as ReactComponent };